<app-resources [surveyData]="survey.data"></app-resources>